// extracted by mini-css-extract-plugin
var _1 = "Avatar__bg--jkeY8";
var _2 = "Avatar__bgDefault--QJU2c Avatar__bg--jkeY8";
var _3 = "Avatar__bgHidden--YeZIF Avatar__bgDefault--QJU2c Avatar__bg--jkeY8";
var _4 = "Avatar__bgOpaque--zgCNB Avatar__bgDefault--QJU2c Avatar__bg--jkeY8";
var _5 = "Avatar__clickThrough--qUYK1";
var _6 = "Avatar__letterImg--CUY7E CoreGeneral__roboto--UlmjE";
var _7 = "Avatar__link--YTGos";
var _8 = "Avatar__main--rWMXl";
var _9 = "Avatar__ring--jye7n";
var _a = "Avatar__wrapper--ADPGr";
export { _1 as "bg", _2 as "bgDefault", _3 as "bgHidden", _4 as "bgOpaque", _5 as "clickThrough", _6 as "letterImg", _7 as "link", _8 as "main", _9 as "ring", _a as "wrapper" }
